/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import { Fragment } from 'react';
import * as dc from '@/lib/dc';
import { Toggle } from '@pointfive/ui';
import type { ViewModel } from './view-model';

export function DigestView({ m }: { m: ViewModel }) {
  return (
    <div style={{ padding: '20px 12px 40px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
      {' '}
      <div>
        {' '}
        <div style={{ display: 'flex', alignItems: 'center', gap: '9px' }}>
          <i className="ph ph-envelope-simple" style={{ fontSize: '17px', color: 'var(--acc-2)' }}></i>
          <span style={{ fontSize: '15px', fontWeight: '500', letterSpacing: '-0.01em' }}>
            Performance Digest
          </span>
        </div>{' '}
        <div style={{ fontSize: '11.5px', color: 'var(--muted)', marginTop: '3px' }}>
          Weekly and monthly performance summaries with AI-powered insights
        </div>{' '}
      </div>{' '}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,280px),1fr))',
          gap: '14px',
          alignItems: 'start',
        }}
      >
        {' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            padding: '16px 18px',
          }}
        >
          {' '}
          <div style={{ fontSize: '12px', fontWeight: '500' }}>Digest Settings</div>{' '}
          <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
            Configure your automated performance reports
          </div>{' '}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '13px', marginTop: '14px' }}>
            {' '}
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <i className="ph ph-calendar-blank" style={{ fontSize: '13px', color: 'var(--muted2)' }}></i>
              <span style={{ fontSize: '11.5px', flex: '1' }}>Weekly Digest</span>
              <Toggle
                trackBg={m.dgWeeklyTog?.track}
                knobBg={m.dgWeeklyTog?.knobBg}
                knob={m.dgWeeklyTog?.knob}
                onClick={m.dgWeeklyTog?.go}
                aria-label="Toggle"
                aria-pressed={dc.b(m.dgWeeklyTog?.on)}
              />
            </div>{' '}
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <i className="ph ph-calendar-blank" style={{ fontSize: '13px', color: 'var(--muted2)' }}></i>
              <span style={{ fontSize: '11.5px', flex: '1' }}>Monthly Digest</span>
              <Toggle
                trackBg={m.dgMonthlyTog?.track}
                knobBg={m.dgMonthlyTog?.knobBg}
                knob={m.dgMonthlyTog?.knob}
                onClick={m.dgMonthlyTog?.go}
                aria-label="Toggle"
                aria-pressed={dc.b(m.dgMonthlyTog?.on)}
              />
            </div>{' '}
          </div>{' '}
          <div style={{ height: '1px', background: 'var(--l6)', margin: '14px 0' }}></div>{' '}
          <div
            style={{
              fontSize: '9px',
              letterSpacing: '0.11em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            Weekly Report Day
          </div>{' '}
          <div
            style={{
              display: 'flex',
              gap: '2px',
              padding: '3px',
              borderRadius: '99px',
              border: '1px solid var(--l8)',
              marginTop: '7px',
            }}
          >
            {' '}
            {(m.dgDayOpts ?? []).map((d, i195) => (
              <Fragment key={i195}>
                {' '}
                <button
                  onClick={d?.go}
                  aria-label={dc.a(d?.label)}
                  style={dc.css(
                    `flex:1;padding:4px 6px;border-radius:99px;border:none;background:${dc.s(d?.bg)};color:${dc.s(d?.fg)};font-size:10px;cursor:pointer`,
                  )}
                >
                  {dc.t(d?.label)}
                </button>{' '}
              </Fragment>
            ))}{' '}
          </div>{' '}
          <div style={{ height: '1px', background: 'var(--l6)', margin: '14px 0' }}></div>{' '}
          <div
            style={{
              fontSize: '9px',
              letterSpacing: '0.11em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            Include in Report
          </div>{' '}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '10px' }}>
            {' '}
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ fontSize: '11.5px', flex: '1' }}>AI Insights</span>
              <Toggle
                trackBg={m.dgAiTog?.track}
                knobBg={m.dgAiTog?.knobBg}
                knob={m.dgAiTog?.knob}
                onClick={m.dgAiTog?.go}
                aria-label="Toggle"
                aria-pressed={dc.b(m.dgAiTog?.on)}
              />
            </div>{' '}
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ fontSize: '11.5px', flex: '1' }}>Trade Log</span>
              <Toggle
                trackBg={m.dgLogTog?.track}
                knobBg={m.dgLogTog?.knobBg}
                knob={m.dgLogTog?.knob}
                onClick={m.dgLogTog?.go}
                aria-label="Toggle"
                aria-pressed={dc.b(m.dgLogTog?.on)}
              />
            </div>{' '}
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ fontSize: '11.5px', flex: '1' }}>Equity Curve</span>
              <Toggle
                trackBg={m.dgEquityTog?.track}
                knobBg={m.dgEquityTog?.knobBg}
                knob={m.dgEquityTog?.knob}
                onClick={m.dgEquityTog?.go}
                aria-label="Toggle"
                aria-pressed={dc.b(m.dgEquityTog?.on)}
              />
            </div>{' '}
          </div>{' '}
          <button
            className="scp-84a7026"
            onClick={m.dgGen}
            aria-label={dc.a(m.dgGenLabel)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '7px',
              width: '100%',
              marginTop: '16px',
              padding: '10px',
              borderRadius: '11px',
              border: '1px solid color-mix(in srgb, var(--acc-fill) 50%, transparent)',
              background: 'color-mix(in srgb, var(--acc-fill) 10%, transparent)',
              color: 'var(--acc)',
              fontSize: '12px',
              fontWeight: '500',
              cursor: 'pointer',
            }}
          >
            <i className="ph ph-sparkle" style={{ fontSize: '13px' }}></i>
            {dc.t(m.dgGenLabel)}
          </button>{' '}
        </div>{' '}
        <div
          style={{
            gridColumn: 'span 2',
            minWidth: '0',
            display: 'flex',
            flexDirection: 'column',
            gap: '14px',
          }}
        >
          {' '}
          <div
            style={{
              display: 'flex',
              gap: '2px',
              padding: '3px',
              borderRadius: '99px',
              border: '1px solid var(--l8)',
              alignSelf: 'flex-start',
            }}
          >
            {' '}
            {(m.dgTabs ?? []).map((t, i196) => (
              <Fragment key={i196}>
                {' '}
                <button
                  onClick={t?.go}
                  aria-label={dc.a(t?.label)}
                  style={dc.css(
                    `padding:5px 14px;border-radius:99px;border:none;background:${dc.s(t?.bg)};color:${dc.s(t?.fg)};font-weight:${dc.s(t?.fw)};font-size:10.5px;cursor:pointer`,
                  )}
                >
                  {dc.t(t?.label)}
                </button>{' '}
              </Fragment>
            ))}{' '}
          </div>{' '}
          {m.dgIsHistory ? (
            <>
              {' '}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {' '}
                {(m.dgHistory ?? []).map((d, i197) => (
                  <Fragment key={i197}>
                    {' '}
                    <div
                      style={{
                        background: 'var(--surface)',
                        border: '1px solid var(--card-line)',
                        boxShadow: 'var(--shadow-card)',
                        borderRadius: '16px',
                        padding: '14px 16px',
                      }}
                    >
                      {' '}
                      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                        {' '}
                        <div style={{ flex: '1', minWidth: '0' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span
                              style={{
                                fontSize: '9.5px',
                                padding: '1px 8px',
                                borderRadius: '99px',
                                background: 'var(--l6)',
                                color: 'var(--muted)',
                              }}
                            >
                              {dc.t(d?.period)}
                            </span>
                            <span style={{ fontSize: '11.5px', fontWeight: '500' }}>{dc.t(d?.range)}</span>
                          </div>
                        </div>{' '}
                        <div style={{ textAlign: 'right', flex: 'none' }}>
                          <div
                            style={dc.css(
                              `font-size:12.5px;font-weight:600;color:${dc.s(d?.pnlFg)};font-variant-numeric:tabular-nums`,
                            )}
                          >
                            {dc.t(d?.pnl)}
                          </div>
                          <div
                            style={{
                              fontSize: '10px',
                              color: 'var(--muted2)',
                              fontVariantNumeric: 'tabular-nums',
                            }}
                          >
                            {dc.t(d?.trades)}
                          </div>
                        </div>{' '}
                      </div>{' '}
                      <div
                        style={{
                          fontSize: '10.5px',
                          color: 'var(--muted)',
                          lineHeight: '1.55',
                          marginTop: '9px',
                          paddingTop: '9px',
                          borderTop: '1px solid var(--l6)',
                        }}
                      >
                        {dc.t(d?.summary)}
                      </div>{' '}
                    </div>{' '}
                  </Fragment>
                ))}{' '}
              </div>{' '}
            </>
          ) : null}{' '}
          {m.dgBusy ? (
            <>
              {' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '48px 20px',
                  textAlign: 'center',
                }}
              >
                <i className="ph ph-circle-notch" style={{ fontSize: '26px', color: 'var(--acc-2)' }}></i>
                <div style={{ fontSize: '12.5px', color: 'var(--text-mid)', marginTop: '10px' }}>
                  {dc.t(m.dgBusyMsg)}
                </div>
                <div style={{ fontSize: '11px', color: 'var(--faint)', marginTop: '3px' }}>
                  This includes AI analysis of your trading patterns
                </div>
              </div>{' '}
            </>
          ) : null}{' '}
          {m.dgUnmade ? (
            <>
              {' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '48px 20px',
                  textAlign: 'center',
                }}
              >
                <i className="ph ph-envelope-simple" style={{ fontSize: '28px', color: 'var(--ghost)' }}></i>
                <div style={{ fontSize: '13px', color: 'var(--text-mid)', marginTop: '10px' }}>
                  No digest generated yet
                </div>
                <div style={{ fontSize: '11px', color: 'var(--faint)', marginTop: '4px' }}>
                  {dc.t(m.dgEmptyMsg)}
                </div>
              </div>{' '}
            </>
          ) : null}{' '}
          {m.dgMade ? (
            <>
              {' '}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                {' '}
                <div
                  style={{
                    background: 'var(--surface)',
                    border: '1px solid var(--card-line)',
                    boxShadow: 'var(--shadow-card)',
                    borderRadius: '16px',
                    borderColor: 'color-mix(in srgb, var(--acc-fill) 25%, transparent)',
                    padding: '18px 20px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '14px',
                    flexWrap: 'wrap',
                  }}
                >
                  {' '}
                  <div style={{ flex: '1', minWidth: '200px' }}>
                    <div
                      style={{
                        fontSize: '9px',
                        letterSpacing: '0.11em',
                        textTransform: 'uppercase',
                        color: 'var(--muted2)',
                        fontWeight: '600',
                      }}
                    >
                      {dc.t(m.dgPeriodTitle)}
                    </div>
                    <div
                      style={{
                        fontSize: '11.5px',
                        color: 'var(--muted)',
                        marginTop: '4px',
                        fontVariantNumeric: 'tabular-nums',
                      }}
                    >
                      {dc.t(m.dgRange)}
                    </div>
                  </div>{' '}
                  <div style={{ textAlign: 'right' }}>
                    <div
                      style={dc.css(
                        `font-size:22px;font-weight:600;letter-spacing:-0.02em;color:${dc.s(m.dgNetFg)};font-variant-numeric:tabular-nums`,
                      )}
                    >
                      {dc.t(m.dgNet)}
                    </div>
                    <div style={{ fontSize: '10px', color: 'var(--muted2)' }}>Net P&L</div>
                  </div>{' '}
                </div>{' '}
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit,minmax(min(50%,150px),1fr))',
                    gap: '10px',
                  }}
                >
                  {' '}
                  {(m.dgKpis ?? []).map((k, i198) => (
                    <Fragment key={i198}>
                      {' '}
                      <div
                        style={{
                          background: 'var(--surface)',
                          border: '1px solid var(--card-line)',
                          boxShadow: 'var(--shadow-card)',
                          borderRadius: '16px',
                          padding: '11px 13px',
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <i
                            className={`ph ${dc.s(k?.icon)}`}
                            style={dc.css(`font-size:12px;color:${dc.s(k?.c)}`)}
                          ></i>
                          <span style={{ fontSize: '10px', color: 'var(--muted2)' }}>{dc.t(k?.label)}</span>
                        </div>
                        <div
                          style={dc.css(
                            `font-size:15px;font-weight:600;letter-spacing:-0.02em;color:${dc.s(k?.c)};margin-top:4px;font-variant-numeric:tabular-nums`,
                          )}
                        >
                          {dc.t(k?.v)}
                        </div>
                      </div>{' '}
                    </Fragment>
                  ))}{' '}
                </div>{' '}
                {m.dgHasDaily ? (
                  <>
                    {' '}
                    <div
                      style={{
                        background: 'var(--surface)',
                        border: '1px solid var(--card-line)',
                        boxShadow: 'var(--shadow-card)',
                        borderRadius: '16px',
                        padding: '16px 18px',
                      }}
                    >
                      {' '}
                      <div style={{ fontSize: '12px', fontWeight: '500' }}>Daily P&L</div>{' '}
                      <div
                        style={{
                          height: '160px',
                          display: 'flex',
                          flexDirection: 'column',
                          marginTop: '12px',
                        }}
                      >
                        {' '}
                        <div style={{ height: '50%', display: 'flex', alignItems: 'flex-end', gap: '6px' }}>
                          {(m.dgDaily ?? []).map((b, i199) => (
                            <Fragment key={i199}>
                              <div
                                style={{ flex: '1', height: '100%', display: 'flex', alignItems: 'flex-end' }}
                              >
                                {b?.pos ? (
                                  <div
                                    style={dc.css(
                                      `width:100%;max-width:26px;margin:0 auto;height:${dc.s(b?.h)};border-radius:3px 3px 0 0;background:var(--pos)`,
                                    )}
                                  ></div>
                                ) : null}
                              </div>
                            </Fragment>
                          ))}
                        </div>{' '}
                        <div style={{ height: '1px', background: 'var(--l10)' }}></div>{' '}
                        <div style={{ height: '50%', display: 'flex', alignItems: 'flex-start', gap: '6px' }}>
                          {(m.dgDaily ?? []).map((b, i200) => (
                            <Fragment key={i200}>
                              <div style={{ flex: '1', height: '100%' }}>
                                {b?.neg ? (
                                  <div
                                    style={dc.css(
                                      `width:100%;max-width:26px;margin:0 auto;height:${dc.s(b?.h)};border-radius:0 0 3px 3px;background:var(--neg);opacity:0.85`,
                                    )}
                                  ></div>
                                ) : null}
                              </div>
                            </Fragment>
                          ))}
                        </div>{' '}
                      </div>{' '}
                      <div style={{ display: 'flex', gap: '6px', marginTop: '6px' }}>
                        {(m.dgDaily ?? []).map((b, i201) => (
                          <Fragment key={i201}>
                            <span
                              style={{
                                flex: '1',
                                textAlign: 'center',
                                fontSize: '9px',
                                color: 'var(--faint)',
                                fontVariantNumeric: 'tabular-nums',
                              }}
                            >
                              {dc.t(b?.label)}
                            </span>
                          </Fragment>
                        ))}
                      </div>{' '}
                    </div>{' '}
                  </>
                ) : null}{' '}
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,280px),1fr))',
                    gap: '14px',
                    alignItems: 'start',
                  }}
                >
                  {' '}
                  <div
                    style={{
                      background: 'var(--surface)',
                      border: '1px solid var(--card-line)',
                      boxShadow: 'var(--shadow-card)',
                      borderRadius: '16px',
                      padding: '16px 18px',
                    }}
                  >
                    {' '}
                    <div style={{ fontSize: '12px', fontWeight: '500' }}>Highlights</div>{' '}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '9px', marginTop: '11px' }}>
                      {' '}
                      {m.dgHasBest ? (
                        <>
                          {' '}
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '11px',
                              padding: '11px 13px',
                              borderRadius: '11px',
                              border: '1px solid color-mix(in srgb, var(--pos) 22%, transparent)',
                              background: 'color-mix(in srgb, var(--pos) 7%, transparent)',
                            }}
                          >
                            <i className="ph ph-trophy" style={{ fontSize: '15px', color: 'var(--pos)' }}></i>
                            <div style={{ flex: '1' }}>
                              <div style={{ fontSize: '10px', color: 'var(--muted2)' }}>Best Trade</div>
                              <div style={{ fontSize: '11.5px', fontWeight: '500', marginTop: '1px' }}>
                                {dc.t(m.dgBest?.sym)}
                              </div>
                            </div>
                            <span
                              style={{
                                fontSize: '12.5px',
                                fontWeight: '600',
                                color: 'var(--pos)',
                                fontVariantNumeric: 'tabular-nums',
                              }}
                            >
                              {dc.t(m.dgBest?.pnl)}
                            </span>
                          </div>{' '}
                        </>
                      ) : null}{' '}
                      {m.dgHasWorst ? (
                        <>
                          {' '}
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '11px',
                              padding: '11px 13px',
                              borderRadius: '11px',
                              border: '1px solid color-mix(in srgb, var(--neg) 22%, transparent)',
                              background: 'color-mix(in srgb, var(--neg-fill) 7%, transparent)',
                            }}
                          >
                            <i
                              className="ph ph-warning"
                              style={{ fontSize: '15px', color: 'var(--neg)' }}
                            ></i>
                            <div style={{ flex: '1' }}>
                              <div style={{ fontSize: '10px', color: 'var(--muted2)' }}>Worst Trade</div>
                              <div style={{ fontSize: '11.5px', fontWeight: '500', marginTop: '1px' }}>
                                {dc.t(m.dgWorst?.sym)}
                              </div>
                            </div>
                            <span
                              style={{
                                fontSize: '12.5px',
                                fontWeight: '600',
                                color: 'var(--neg)',
                                fontVariantNumeric: 'tabular-nums',
                              }}
                            >
                              {dc.t(m.dgWorst?.pnl)}
                            </span>
                          </div>{' '}
                        </>
                      ) : null}{' '}
                    </div>{' '}
                  </div>{' '}
                  <div
                    style={{
                      background: 'var(--surface)',
                      border: '1px solid var(--card-line)',
                      boxShadow: 'var(--shadow-card)',
                      borderRadius: '16px',
                      padding: '16px 18px',
                    }}
                  >
                    {' '}
                    <div style={{ fontSize: '12px', fontWeight: '500' }}>Symbol Breakdown</div>{' '}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '11px' }}>
                      {' '}
                      {(m.dgSymbols ?? []).map((s, i202) => (
                        <Fragment key={i202}>
                          {' '}
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '12px',
                              padding: '7px 12px',
                              borderRadius: '9px',
                              background: 'var(--l4)',
                            }}
                          >
                            <span style={{ fontSize: '11.5px', fontWeight: '500', flex: '1' }}>
                              {dc.t(s?.sym)}
                            </span>
                            <span
                              style={{
                                fontSize: '10px',
                                color: 'var(--muted2)',
                                fontVariantNumeric: 'tabular-nums',
                              }}
                            >
                              {dc.t(s?.n)}
                            </span>
                            <span
                              style={dc.css(
                                `font-size:11.5px;font-weight:600;color:${dc.s(s?.pnlFg)};font-variant-numeric:tabular-nums`,
                              )}
                            >
                              {dc.t(s?.pnl)}
                            </span>
                          </div>{' '}
                        </Fragment>
                      ))}{' '}
                    </div>{' '}
                    {m.dgNoSymbols ? (
                      <div style={{ fontSize: '11px', color: 'var(--faint)', marginTop: '9px' }}>
                        No symbol data available
                      </div>
                    ) : null}{' '}
                  </div>{' '}
                </div>{' '}
                {m.dgAiTog?.on ? (
                  <>
                    {' '}
                    <div
                      style={{
                        background: 'var(--surface)',
                        border: '1px solid var(--card-line)',
                        boxShadow: 'var(--shadow-card)',
                        borderRadius: '16px',
                        borderColor: 'color-mix(in srgb, var(--acc-fill) 22%, transparent)',
                        padding: '16px 18px',
                      }}
                    >
                      {' '}
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                        {' '}
                        <span
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '7px',
                            fontSize: '12px',
                            fontWeight: '500',
                            color: 'var(--acc)',
                          }}
                        >
                          <i className="ph-fill ph-sparkle" style={{ fontSize: '14px' }}></i>AI Performance
                          Summary
                        </span>{' '}
                        <div style={{ flex: '1' }}></div>{' '}
                        <button
                          className="scp-4f3e86a"
                          onClick={m.dgSend}
                          aria-label="Forward to investors"
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px',
                            fontSize: '11px',
                            padding: '5px 12px',
                            borderRadius: '99px',
                            border: '1px solid var(--l10)',
                            background: 'transparent',
                            color: 'var(--muted)',
                            cursor: 'pointer',
                          }}
                        >
                          <i className="ph ph-paper-plane-tilt" style={{ fontSize: '12px' }}></i>Forward
                        </button>{' '}
                      </div>{' '}
                      <div
                        style={{ display: 'flex', flexDirection: 'column', gap: '9px', marginTop: '11px' }}
                      >
                        {' '}
                        {(m.dgAiParas ?? []).map((p, i203) => (
                          <Fragment key={i203}>
                            <div
                              style={{
                                fontSize: '11.5px',
                                color: 'var(--text-mid)',
                                lineHeight: '1.65',
                                maxWidth: '88ch',
                              }}
                            >
                              {dc.t(p?.t)}
                            </div>
                          </Fragment>
                        ))}{' '}
                      </div>{' '}
                    </div>{' '}
                  </>
                ) : null}{' '}
                <button
                  className="scp-2223d55"
                  onClick={m.dgArchive}
                  aria-label="Save digest to archive"
                  style={{
                    alignSelf: 'flex-end',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '6px',
                    fontSize: '11.5px',
                    padding: '7px 14px',
                    borderRadius: '99px',
                    border: '1px solid var(--l12)',
                    background: 'transparent',
                    color: 'var(--text-mid)',
                    cursor: 'pointer',
                  }}
                >
                  <i className="ph ph-archive" style={{ fontSize: '12px' }}></i>Save to archive
                </button>{' '}
              </div>{' '}
            </>
          ) : null}{' '}
        </div>{' '}
      </div>
    </div>
  );
}
